import React from 'react';
import { Table } from 'react-bootstrap';
import Formats from 'utils/formats';
import './styles.scss';
import QueryRetryWrapper from 'components/QueryRetryWrapper';

interface RowType {
  id: any;
  name: string;
  value: string;
}

interface Props {
  clientID: string;
  globalFilter: any;
  nameHeader?: string;
  valueHeader?: string;
  query: any;
  onRowClick?: (any) => void;
  onViewAllClick?: () => void;
  portfolio?: boolean;
}

const formatValue = (value: number, valueHeader: string) => {
  switch (valueHeader) {
    case 'POD Gains':
    case 'POD Losses':
      return Formats.number(value, 0, true);
    case 'Opportunities':
      return Formats.currency(value);
    default:
      return value;
  }
};

const OverviewTable: React.FC<Props> = ({
  clientID,
  globalFilter,
  nameHeader,
  valueHeader,
  query,
  onRowClick,
  onViewAllClick,
  portfolio
}) => (
  <QueryRetryWrapper
    query={query}
    variables={{
      clientID: clientID,
      globalFilter: globalFilter
    }}
    fetchPolicy="cache-first"
  >
    {({ data }) => {
      if (data) {
        const columnNames = (
          <tr>
            <th>{valueHeader}</th>
            <th>
              {nameHeader}
              {!portfolio && (
                <span className="view-all" onClick={onViewAllClick}>
                  View All
                </span>
              )}
            </th>
          </tr>
        );

        const dataArray = data[Object.keys(data)[0]];
        return (
          <Table className="overview-table" responsive>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <thead>{columnNames}</thead>
            <tbody className={portfolio ? '' : 'default'}>
              {dataArray &&
                dataArray.data &&
                dataArray.data.map(
                  (row: { amount: number; label: React.ReactNode }, index: React.ReactText) => (
                    <tr
                      key={index}
                      onClick={() => (onRowClick ? onRowClick(row) : {})}
                      className={onRowClick ? '' : 'non-clickable'}
                    >
                      <td>{formatValue(row.amount, valueHeader)}</td>
                      <td>{row.label}</td>
                    </tr>
                  )
                )}
            </tbody>
          </Table>
        );
      }
    }}
  </QueryRetryWrapper>
);

export default OverviewTable;
